import departmentTypes from './departments.types';

export const INITIAL_STATE = {
  departments: {
    loading: false,
    data: {},
  },
  deleteLoading: false,
  editAddLoading: false,
};

const departmentsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case departmentTypes.SET_DEPARTMENTS:
      return {
        ...state,
        departments: {
          loading: false,
          data: action.payload,
        },
      };

    case departmentTypes.LOADING_DEPARTMENTS:
      return {
        ...state,
        departments: {
          ...state.departments,
          loading: true,
          data: state.departments.data,
        },
      };
    case departmentTypes.SET_LOADING_DELETE_DEPARTMENT:
      return {
        ...state,
        deleteLoading: action.payload,
      };
    case departmentTypes.SET_LOADING_EDIT_ADD_DEPARTMENT:
      return {
        ...state,
        editAddLoading: action.payload,
      };
    case departmentTypes.REMOVE_DEPARTMENT_FROM_LIST: {
      const teamId = action.payload;
      const newTeamsList = state.departments.data.teams.filter((team) => {
        return team._id !== teamId;
      });
      return {
        ...state,
        departments: {
          ...state.departments,
          data: {
            ...state.departments.data,
            teams: newTeamsList,
          },
        },
      };
    }
    case departmentTypes.SET_EDITED_DEPARTMENT: {
      const editedDepartment = action.payload;
      const newDepartments = state.departments.data.teams.map((team) => {
        if (team._id === editedDepartment._id) {
          return editedDepartment;
        }
        return team;
      });

      return {
        ...state,
        departments: {
          data: {
            ...state.departments.data,
            teams: newDepartments,
          },
        },
      };
    }

    default:
      return state;
  }
};

export default departmentsReducer;
